import { createDataTool } from "./data-tool-app.js";
import { formatXml } from "./xml-formatter-core.js";
import "./data-tool.css";

createDataTool({
  inputLabel: "XML",
  outputLabel: "XML",
  extensions: ["xml"],
  defaultFileName: "document.xml",
  exampleFileName: "catalog.xml",
  example: '<?xml version="1.0"?><catalog><book id="1"><title>Practical Tools</title><available>true</available></book></catalog>',
  outputExtension: "xml",
  mimeType: "application/xml",
  suffix: "formatted",
  transform(source, mode) {
    const compact = mode === "secondary";
    const result = formatXml(source, {
      indentation: document.getElementById("dataToolIndentation")?.value || 2,
      compact
    });
    if (!result.error) {
      const parsed = new DOMParser().parseFromString(source, "application/xml");
      if (parsed.querySelector("parsererror")) {
        return { error: "Invalid XML. Check namespaces, entities, attributes, and element structure.", output: "" };
      }
    }
    return {
      ...result,
      suffix: compact ? "minified" : "formatted",
      message: result.error ? "" : compact
        ? `Valid XML minified to ${result.output.length.toLocaleString("en-US")} characters.`
        : `Valid XML formatted across ${result.lines.toLocaleString("en-US")} lines.`
    };
  },
  successMessage: result => `Valid XML formatted across ${result.lines.toLocaleString("en-US")} lines.`
});
